import { UI, IconButtonTypes, HStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import React from 'react';

export interface BasketLinkProps {
  onPress: IconButtonTypes.Props['onPress'];
}

export const BasketLink: React.FC<BasketLinkProps> = ({ onPress }) => {
  return (
    <HStack space={Spacing['inline.quarck']} alignItems="center">
      <UI.Icon name="Basket" size="xxs" color={Color['brand.tertiary.dark']} />
      <UI.IconButton
        p={0}
        icon="OpenPage"
        iconSize="xxs"
        iconColor={Color['brand.tertiary.principal']}
        testId="basket-link"
        onPress={onPress}
      />
    </HStack>
  );
};
